import React, { useContext, useState, useEffect, useRef } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { FiAlertTriangle } from "react-icons/fi";
import { Container, Col, Button, Row } from "react-bootstrap";
import "./ServiceDetails.scss";
import { useHistory } from "react-router-dom";
import { useQuery, gql, useMutation, useLazyQuery } from "@apollo/client";
import { MyContext } from "../Dashboard/Dashboard";
import Loader from "react-loader-spinner";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Toast } from "primereact/toast";
import CloseButton from "react-bootstrap/CloseButton";
import moment, { duration } from "moment";
import { Calendar } from "primereact/calendar";
import ReactTooltip from "react-tooltip";
import { getUserContacts } from "../Comments/CommentService";
import { getCountryCallingCode } from "react-phone-number-input";
const COMMENT_TEMPLATES = [
  {
    label: "Scheduled maintenance",
    text: "Approved for scheduled maintenance in line with the planned service window.",
  },
  {
    label: "Troubleshooting reported issue",
    text: "Approved to troubleshoot the reported issue on this vessel's network.",
  },
  {
    label: "Software / firmware update",
    text: "Approved for software/firmware update as per change request.",
  },
  {
    label: "Approved on behalf of Vessel Master",
    text: "Approved - confirmed with vessel master prior to granting access.",
  },
  {
    label: "Routine remote support",
    text: "Approved for routine remote support, no operational impact expected.",
  },
  {
    label: "Insufficient justification",
    text: "Denied - insufficient justification provided for this access request.",
  },
  {
    label: "Outside approved hours",
    text: "Denied - requested window falls outside approved access hours.",
  },
  {
    label: "Security concern",
    text: "Denied - potential security or compliance concern, escalating for review.",
  },
  {
    label: "Duplicate request",
    text: "Denied - duplicate of an existing approved or pending request.",
  },
  {
    label: "Awaiting more information",
    text: "Denied - awaiting further information from the requester before approval.",
  },
  {
    label: "Should be covered under warranty",
    text: "Request was not made under warranty, but should be covered under warranty.",
  },
];
const ServiceDetails = (props) => {
  let {
    serviceRecordList,
    vesselIMO,
    vesselImage,
    vesselName,
    setServiceRecordList,
  } = useContext(MyContext);
  const toast = useRef(null);
  let history = useHistory();
  const {
    match: { params },
  } = props;

  const { cid, vid, serviceId } = params;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [serviceWorkflowList, setWorkflowDetails] = useState([]);
  const [latestEntry, setLatestEntry] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledApprove, setIsDisabledApprove] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [userRole, setUserRole] = useState("");
  const [disableButton, setDisableRequestButton] = useState(false);
  const [actionType, setAction] = useState("");
  const [workFlowPending, setWorkFlowPending] = useState([]);
  const [assignToUser, setCreatedUserId] = useState("");
  const [createdUserRole, setCreatedUserRole] = useState("");
  const [createdUser, setCreatedUser] = useState("");
  const [assignedToRole, setAssignedToRole] = useState("");
  const [vesselRefresh, setVesselName] = useState("");
  const [serviceListDetails, setServiceDetails] = useState([]);
  const [serviceAssignee, setAssigneeDetails] = useState([]);
  const [selectedStartDate, setDateStart] = useState(null);
  const [selectedEndDate, setDateEnd] = useState(null);
  const [minimumStartDate, setMinimumStartDate] = useState(new Date());
  const [secondsDifference, setSeconds] = useState(0);
  const [contactDetails, setContactDetails] = useState([]);
  const [contactLoading, setContactLoading] = useState(false);
  const [estimatedDate, setEstimatedStartDate] = useState(null);
  const [displayCalendar, showCalendar] = useState(false);
  const [duration, setDuration] = useState(null);
  const [hasReportWorkSet, setReportFlag] = useState(false);
  const [difference, setDifference] = useState(null);
  const [errors, setErrors] = useState({});
  const [vesselInfo, setVesselInfo] = useState("");
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [hasContactedEngineer, setHasContactedEngineer] = useState(false);
  const [revokeReason, setRevokeReason] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [engineerName, setEngineerName] = useState("");
  const [reportedWorkData, setReportedWorkData] = useState(null);
  const [showRecordEditedModal, setShowRecordEditedModal] = useState(false);
  const handleEditClose = () => setShowRecordEditedModal(false);
  const [showApproveConfirmation, setShowApproveConfirmation] = useState(false);
  const [recordEditedDate, setRecordEditedDate] = useState(null);
  const [selectedCommentTemplate, setSelectedCommentTemplate] = useState("");
  const [isRequestLoaded, setIsRequestLoaded] = useState(false);
  const [isVesselLoaded, setIsVesselLoaded] = useState(false);
  useEffect(() => {
    if (vesselInfo) {
      getRequestDetails();
    }
    localStorage.setItem("service", serviceRecordList);
    serviceRecordList = serviceRecordList
      ? serviceRecordList
      : localStorage.getItem("service");
    let serviceStore = localStorage.getItem("service");
    setIsDisabled(false);
    setIsDisabledApprove(false);
    getVessels();
    getRoles();
  }, []);

  let today = new Date();
  let minDate = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  minDate.setMonth(month);
  minDate.setFullYear(year);
  minDate.setHours(0, 0, 0, 0);
  useEffect(() => { }, [serviceRecordList]);
  useEffect(() => { }, [vesselIMO]);
  useEffect(() => { }, [vesselImage]);
  useEffect(() => { }, [vesselName]);

  const showToaster = () => {
    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Request Submitted Successfully",
      life: 3000,
    });
  };

  const showToasterFailure = (err) => {
    toast.current.show({
      severity: "error",
      summary: "Error",
      detail: err,
      life: 3000,
    });
  };

  const populateCommentValue = (event) => {
    setCommentValue(event.target.value);
  };
  const commentTemplates = {
    "Approve Reasons": [
      "Scheduled maintenance",
      "Troubleshooting reported issue",
      "Software / firmware update",
      "Approved on behalf of Vessel Master",
      "Routine remote support",
    ],
    "Deny Reasons": [
      "Should be covered under warranty",
      "Insufficient justification",
      "Outside approved hours",
      "Security / compliance concern",
      "Duplicate request",
      "Awaiting more information",
    ],
  };
  const cancelAction = () => {
    setCommentValue("");
    setShow(false);
    setIsDisabledApprove(false);
    setIsDisabled(false);
    showCalendar(false);
    setErrors({});
    setSelectedCommentTemplate("");
  };

  const REVOKE_GUARD_REQUEST = gql`
    mutation updateRemoteAccessSession(
      $vesselId: Int!
      $customerId: Int!
      $remoteAccessSessionActionInput: RemoteAccessSessionActionInput!
    ) {
      updateRemoteAccessSession(
        vesselId: $vesselId
        customerId: $customerId
        remoteAccessSessionActionInput: $remoteAccessSessionActionInput
      )
    }
  `;
  const Vessel_query = gql`
     query 
     { 
      vesselsByCustomer(id: ${cid})
          {
            id,
            name,
            imo,
            mmsi,
            description,
            imageURL,
            typeDescription,
            displayName,
            contactNumber,
            timezone,
            isMrvEnabled,
            classSociety,
            maxRemoteAccessDuration
          }
    }`;
  const [
    revokeSession,
    {
      loading: revokeSessionloading,
      error: revokeSessionerror,
      data: revokeSessiondata,
    },
  ] = useMutation(REVOKE_GUARD_REQUEST, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      if (resp) {
        showToaster();
        setRevokeReason("");
        setHasContactedEngineer(false);
        getRequestDetails();
      }
    },
    onError(err) {
      const errorMessage = err?.message || "An unexpected error occurred";
      showToasterFailure(errorMessage);
      setShowRevokeModal(false);
      setRevokeReason("");
      setHasContactedEngineer(false);
    },
  });

  const [getVessels, { loadingVessels, errorVessels, dataVessels }] =
    useLazyQuery(Vessel_query, {
      fetchPolicy: "cache-and-network",
      onCompleted(resp) {
        let vessel = resp.vesselsByCustomer.find(
          (vessel) => vessel.id === parseInt(vid),
        );

        setVesselInfo(vessel);
        getRequestDetails();
        setIsVesselLoaded(true);
      },
    });
  const [roleCode, setCurrentUserRole] = useState();
  const [roleName, setCurrentUserRoleName] = useState();

  const Roles_query = gql`
    query{appVesselUserRole(custId:${cid},vesselId:${vid}){code,role}}`;
  const [
    getRoles,
    { loading: loadingRoles, error: errorRoles, data: dataRoles },
  ] = useLazyQuery(Roles_query, {
    fetchPolicy: "cache-and-network",
    onCompleted(resp) {
      if (resp && resp.appVesselUserRole && resp.appVesselUserRole.code) {
        setCurrentUserRole(resp.appVesselUserRole.code);
        setCurrentUserRoleName(resp.appVesselUserRole.role);
      }
    },
  });
  const handleCommentTemplateChange = (e) => {
    const selected = COMMENT_TEMPLATES.find(
      (item) => item.label === e.target.value
    );

    setSelectedCommentTemplate(e.target.value);

    if (selected) {
      setCommentValue(selected.text);
    }
  };
  const details_query = gql`
    query {
      serviceRecordDetails(vesselId: ${vid}, custId: ${cid}, requestId: ${serviceId}) {
        currentWorkflowDetails {
          workflow
          status
          comments
          assignedDate
          assignedToRole
          assignedToUser
          createdUserRole
          createdUser
          createdUserId
          approverRoleCode
          approverRoleName
          estimateStartDate
          estimateEndDate
        }
        revokeDetails {
          comments
          assignedDate
          createdUser
          createdUserId
        }
        pendingRequests
        assigneeJob
        createdDate
        serviceRequestTypeCode
        description
        equipment
        title
        isWarrantyEnabled
        pendingWorkFlows
        configureStatus
        deviceBehindSm
        revokeAccessEnabled        
        editedDate
      }
    }
  `;

  const handleStartDateChange = (e) => {
    const nextStartDate = e.value;
    if (!nextStartDate) return;

    const currentInterval = selectedStartDate && selectedEndDate
      ? selectedEndDate.getTime() - selectedStartDate.getTime()
      : 0;
    const nextEndDate = currentInterval > 0
      ? new Date(nextStartDate.getTime() + currentInterval)
      : selectedEndDate && selectedEndDate >= nextStartDate
        ? selectedEndDate
        : new Date(nextStartDate);

    setDateStart(nextStartDate);
    setDateEnd(nextEndDate);
    calculateDuration(nextEndDate, nextStartDate);
  };
  // Fetch user contacts from external API
  const getContactDetails = async (cid, userId) => {
    setContactLoading(true);
    try {
      const response = await getUserContacts(cid, userId);
      if (response) {
        setContactLoading(false);
        setContactDetails(response);
        const countryCode = response.PhoneCountryCode;
        let phoneCode = countryCode
          ? getCountryCallingCode(countryCode.toUpperCase())
          : "";
        let phoneNumber = response.PhoneNumber
          ? `+${phoneCode} ${response.PhoneNumber}`
          : "Contact number not available";
        setPhoneNumber(phoneNumber);
        setEngineerName(response.Name);
      } else {
        setContactLoading(false);
        setPhoneNumber("Contact number not available");
      }
    } catch (error) {
      setContactLoading(false);
    }
  };

  const [getRequestDetails, { loading, error, data }] = useLazyQuery(
    details_query,
    {
      fetchPolicy: "cache-and-network",
      onCompleted(resp) {
        if (resp) {
          let modifiedArray = JSON.parse(
            JSON.stringify(resp.serviceRecordDetails.currentWorkflowDetails),
          );
          let maxRemoteAccessDuration =
            vesselInfo?.maxRemoteAccessDuration ?? 12;


          const requestedAccess =
            resp.serviceRecordDetails.currentWorkflowDetails[0];
          let startDate = requestedAccess?.estimateStartDate;
          let endDate = requestedAccess?.estimateEndDate;

          if (endDate == null && startDate != null) {
            endDate =
              startDate + maxRemoteAccessDuration * 60 * 60 * 1000;
          }
          const reportedWorkData = modifiedArray.find(
            (item) => item.workflow === "Report Work",
          );
          setIsRequestLoaded(true);
          setReportedWorkData(reportedWorkData);

          let response1 = JSON.parse(JSON.stringify(resp));

          const sr = response1?.serviceRecordDetails;
          const createdDateText =
            "Request was created on : " +
            moment
              .utc(sr.createdDate, "M/D/YYYY hh:mm:ss A")
              .local()
              .format("DD-MM-YYYY HH:mm:ss a");

          const response = {
            ...resp, // keep everything else from resp
            serviceRecordDetails: {
              ...sr,
              createdDateText,
            },
          };

          const hasReportWork = modifiedArray.some(
            (item) => item.workflow === "Report Work",
          );
          setReportFlag(hasReportWork);
          const duration = endDate
            ? moment.duration(moment(endDate).diff(moment(startDate)))
            : null;
          setDuration(duration);
          setServiceDetails(response.serviceRecordDetails);
          setAssigneeDetails(
            resp.serviceRecordDetails.currentWorkflowDetails[0],
          );
          let workFlowSteps = JSON.parse(
            JSON.stringify(resp.serviceRecordDetails.pendingWorkFlows),
          );
          let workFlowStepsPending = JSON.parse(
            JSON.stringify(resp.serviceRecordDetails.pendingWorkFlows),
          );
          if (
            resp.serviceRecordDetails.currentWorkflowDetails[0].createdUserId
          ) {
            const userId =
              resp.serviceRecordDetails.currentWorkflowDetails[0].createdUserId;
            getContactDetails(cid, userId);
          }
          setDateStart(
            startDate ? new Date(startDate) : null
          );

          setDateEnd(
            endDate ? new Date(endDate) : null
          );

          let service = {
            estimateStartDate: startDate ? moment(startDate).valueOf() : null,
            estimateEndDate: endDate ? moment(endDate).valueOf() : null,
          };
          let durationDifference = getDuration(service);
          setDifference(durationDifference);
          let last = modifiedArray[modifiedArray.length - 1];
          if (last.statusCode !== "cancelled") {
            setWorkflowDetails(modifiedArray);
            let lastItem = modifiedArray[modifiedArray.length - 1];
            setLatestEntry(lastItem);
            workFlowStepsPending.splice(0, 1);
            setWorkFlowPending(workFlowStepsPending);
            let capObj = {
              comments: "",
              createdUserRole: last.assignedToRole,
              createdUser: last.assignedToUser ? last.assignedToUser : "",
              assignedDate: last.assignedDate,
              status: "Pending",
              workflow: workFlowSteps[0],
              manipulated: true,
              approverRoleName: last.approverRoleName,
              approverRoleCode: last.approverRoleCode,
            };
            setCreatedUserId(last.createdUserId);
            setCreatedUserRole(last.createdUserRole);
            setCreatedUser(last.createdUser);
            showCalendar(false);
            setAssignedToRole(last.assignedToRole);
            modifiedArray = Object.assign([], this.modifiedArray);
            if (capObj.workflow != undefined) {
              modifiedArray.push(capObj);
            }
            let array = [
              ...resp.serviceRecordDetails.currentWorkflowDetails,
              ...modifiedArray,
            ];
            setWorkflowDetails(array);
          } else {
            setWorkflowDetails(modifiedArray);
            setCreatedUserId(last.createdUserId);
            setCreatedUserRole(last.createdUserRole);
            setCreatedUser(last.createdUser);
            setAssignedToRole(last.assignedToRole);
            setWorkFlowPending(workFlowStepsPending);
          }
        }
      },
      onError() {
        setIsRequestLoaded(true);
      }
    },
  );

  const APPROVE_DENY_REQUEST = gql`
    mutation upsertServiceRecord(
      $vesselId: Int!
      $custId: Int!
      $serviceRecordInput: ServiceRecordInput!
    ) {
      upsertServiceRecord(
        vesselId: $vesselId
        custId: $custId
        serviceRecordInput: $serviceRecordInput
      )
    }
  `;
  const isCurrentTimeBetween = (startMs, endMs, inclusive = true) => {
    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return false;
    if (startMs > endMs) return false;

    const start = moment(startMs);
    const end = moment(endMs);
    const now = moment();

    return now.isBetween(start, end, undefined, inclusive ? "[]" : "()");
  };
  const revokeRequestSession = () => {
    let revokeParams = {
      requestId: +serviceId,
      workflowCode: "REVOKE_ACCESS",
      statusCode: "COMPLETED",
      comments: revokeReason,
    };
    revokeSession({
      variables: {
        vesselId: +vid,
        customerId: +cid,
        remoteAccessSessionActionInput: revokeParams,
      },
    });
  };
  const approveDenyAccess = (requestDetail, action) => {
    const validationErrors = {};
    if (
      !selectedStartDate ||
      isNaN(moment(selectedStartDate).valueOf())
    ) {
      validationErrors.selectedStartDate = "Start date is required";
    }

    if (
      !selectedEndDate ||
      isNaN(moment(selectedEndDate).valueOf())
    ) {
      validationErrors.selectedEndDate = "End date is required";
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      showCalendar(false);
      return;
    }

    const startEpoch = selectedStartDate.getTime();
    const endEpoch = selectedEndDate.getTime();

    if (
      !Number.isFinite(startEpoch) ||
      !Number.isFinite(endEpoch)
    ) {
      setErrors({
        selectedEndDate: "Invalid start/end date",
      });
      return;
    }

    if (endEpoch < startEpoch) {
      setErrors({
        selectedEndDate: "End time must be the same as or later than the start time.",
      });
      return;
    }

    if (action === "approve") {
      if (moment(endEpoch).isBefore(moment())) {
        setErrors({
          selectedEndDate:
            "The desired end time is in the past. Please select a new end time and proceed.",
        });
        return;
      }

      if (
        moment(endEpoch).isAfter(moment()) &&
        moment(endEpoch)
          .clone()
          .subtract(15, "minutes")
          .isBefore(moment())
      ) {
        setErrors({
          selectedStartDate:
            "The desired end time is too close to the current time. Please select a new time and proceed.",
        });
        return;
      }
    }

    setErrors({});
    setAction(action);

    const formdetails = {
      serviceTypeCode: requestDetail.serviceRequestTypeCode,
      title: requestDetail.title,
      comments: commentValue,
      requestId: +serviceId,
      workflowCode: "REQUEST_APPROVAL",
      statusCode: action === "approve" ? "COMPLETED" : "CANCELLED",
      assignToRole: "SER",
      assignToUser: assignToUser,
      estimateStartDate: startEpoch,
      estimateEndDate: endEpoch,
    };


    setIsDisabledApprove(true);
    setIsDisabled(true);

    approveDenyRequest({
      variables: {
        vesselId: +vid,
        custId: +cid,
        serviceRecordInput: formdetails,
        action,
      },
    });
  };

  const [
    approveDenyRequest,
    {
      loading: approveDenyloading,
      error: approveDenyerror,
      data: approveDenydata,
    },
  ] = useMutation(APPROVE_DENY_REQUEST, {
    fetchPolicy: "network-only",
    onCompleted(resp) {
      if (resp?.upsertServiceRecord?.recordEdited) {
        setRecordEditedDate(serviceListDetails?.editedDate);
        setShowRecordEditedModal(true);
        return;
      }
      if (resp.upsertServiceRecord.status === "Success") {
        showToaster();
        setTimeout(
          () =>
            history.push(
              `/customers/${cid}/vessel/${vid}/operations/serviceRequest`,
            ),
          3500,
        );
        showCalendar(false);
      }
    },
    onError(err) {
      const errorMessage = err?.message || "An unexpected error occurred";
      showToasterFailure(errorMessage);
      setCommentValue("");
      setShow(false);
      setIsDisabledApprove(false);
      setIsDisabled(false);
      showCalendar(false);
      setErrors({});
      setSelectedCommentTemplate("");
      setTimeout(
        () =>
          history.push(
            `/customers/${cid}/vessel/${vid}/operations/serviceRequest`,
          ),
        3500,
      );
    },
  });
  const handleRefreshRequest = () => {
    setIsRequestLoaded(false);
    setShowRecordEditedModal(false);
    setSelectedCommentTemplate("");
    setCommentValue("")
    getRequestDetails();
    setIsDisabled(false)
    setIsDisabledApprove(false)
  };
  const showCalenderSelect = () => {
    showCalendar(true);
  };
  const handleDateChange = (e) => {
    showCalendar(false);
    setDateStart(e);
    getDateReadableFormat(moment(e).valueOf());
  };
  const getDateFormat = (date) => {
    return moment.utc(date).local().format("DD-MM-YYYY HH:mm:ss a");
  };
  const getFormattedDate = (date) => {
    return moment.utc(date).local().format("DD-MM-YYYY hh:mm:ss A");
  };
  const getDateReadableFormat = (date) => {
    let date1 = date / 1000;
    if (date != undefined) {
      setEstimatedStartDate(moment.unix(date1).format("DD-MM-YYYY HH:mm:ss a"));
    }
  };

  const calculateDuration = (endDate, startDate = selectedStartDate) => {
    let service = {
      estimateStartDate: startDate
        ? moment(startDate).valueOf()
        : null,
      estimateEndDate: endDate ? moment(endDate).valueOf() : null,
    };
    let durationDifference = getDuration(service);
    setDifference(durationDifference);
    if (service.estimateStartDate && service.estimateEndDate) {
      setDuration(
        moment.duration(service.estimateEndDate - service.estimateStartDate),
      );
    }
  };

  const getDuration = (service) => {
    if (
      !service?.estimateStartDate ||
      !service?.estimateEndDate ||
      isNaN(service.estimateStartDate) ||
      isNaN(service.estimateEndDate)
    ) {
      return "-";
    }

    let startDate = service.estimateStartDate;
    let endDate = service.estimateEndDate;

    const duration = moment.duration(
      moment(endDate).diff(moment(startDate))
    );

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    setSeconds(seconds);

    if (days === 0 && hours === 0) {
      return `${minutes} minutes`;
    }

    if (days === 0) {
      return `${hours} hours ${minutes} minutes`;
    }

    return `${days} days ${hours} hours`;
  };

  const increaseHeight = {
    height: errors.selectedStartDate ? "112px" : "60px",
  };
  const printStatus = (serviceListDetails, service) => {
    if (workFlowPending.length > 0) {
      let currentStatus =
        serviceListDetails.currentWorkflowDetails[
          serviceListDetails.currentWorkflowDetails.length - 1
        ].status;
      if (serviceListDetails.assigneeJob !== "Service Engineer") {
        if (service.approverRoleName !== null) {
          return (
            <span className="pending">
              Pending with {service.approverRoleName}{" "}
              {service.workflow === "Access Request Raised"
                ? " for approval."
                : null}
            </span>
          );
        } else {
          return <span className="pending">Pending</span>;
        }
      } else {
        let today = moment();
        let start = service.estimateStartDate;
        let end = service.estimateEndDate;
        if (currentStatus == "Cancelled") {
          return <span className="cancel">Cancelled</span>;
        } else {
          if (today.isBefore(start, "second")) {
            return (
              <span className="pending">
                Pending with {serviceListDetails.assigneeJob}{" "}
              </span>
            );
          } else if (today.isAfter(end, "second")) {
            return <span>Ended</span>;
          } else {
            return <span className="active">Active</span>;
          }
        }
      }
    } else {
      return <span className="approved">{service.status}</span>;
    }
  };

  const isEpochInPast = (epoch) => {
    if (!epoch || Number.isNaN(epoch)) return false;
    return Date.now() < epoch;
  };

  const pageLoading = !isVesselLoaded || !isRequestLoaded;
  // Example usage: isEpochInPast(latestEntry.estimateEndDate)
  // You can use this function wherever you need to check if the date is in the past
  return (
    <div className="customers service-details-wrapper">
      <h5>TRITON Reporter</h5>
      {(loading || pageLoading) && (
        <div className="loader">
          <Loader
            type="TailSpin"
            color=" #2546B1"
            height={80}
            width={80}
            timeout={300000}
          />
        </div>
      )}
      {!loading && !pageLoading && (
        <>
          <div className="title">
            <div className="request-header">REQUEST DETAILS</div>
            <div className="welcome">
              <div className="user-box">
                {vesselInfo.imageURL && vesselInfo.imageURL !== null ? (
                  <img src={vesselInfo.imageURL} alt="" />
                ) : (
                  <img className="check" src="user-icon" alt="" />
                )}
              </div>
              {vesselName ? (
                <div className="vessel-name">{vesselName}</div>
              ) : (
                <div className="vessel-name">{vesselInfo?.displayName}</div>
              )}
              <div className="vessel-number eqipStyle" data-tip
                data-for="equipment-tooltip">
                <ReactTooltip
                  id="equipment-tooltip"
                  type="dark"
                  effect="solid"
                  place="top"
                  clickable={true}
                >
                  {serviceListDetails.equipment}
                </ReactTooltip>
                {" "}
                {serviceListDetails.equipment}
              </div>
              {vesselInfo && vesselInfo.imo !== null ? (
                <div className="vessel-number imoStyle">
                  IMO : {vesselInfo?.imo}
                </div>
              ) : (
                <div className="vessel-number imoStyle">IMO : N.A</div>
              )}
            </div>
          </div>
          <div className="service-details-wrapper-chief-engineer">
            <div className="issue-description-wrapper-chief-engineer">
              <Row className="issue-container">
                <div class="details-header">
                  <div className="issue-description" role="button">
                    {serviceListDetails.isWarrantyEnabled && (
                      <>
                        <span
                          className={`warranty-icon-indetail`}
                          data-tip
                          data-for="warranty-tooltip-txt"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <ReactTooltip
                            id="warranty-tooltip-txt"
                            type="dark"
                            effect="float"
                            place="right"
                            globalEventOff="click"
                            className="rqst-descrition"
                          >
                            Under Warranty
                          </ReactTooltip>
                          <i className="pi pi-shield"></i>
                          <i className="pi pi-check"></i>
                        </span>
                      </>
                    )}
                    {serviceListDetails.title}
                  </div>
                  <span
                    data-tip
                    data-for="request-details-description"
                    className="description-tool-tip"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    i
                  </span>
                  <ReactTooltip
                    id="request-details-description"
                    type="dark"
                    effect="float"
                    place="right"
                    globalEventOff="click"
                    className="rqst-descrition"
                  >
                    {serviceListDetails.createdDateText}
                  </ReactTooltip>
                </div>
                <div className="issue-time-status">
                  {serviceListDetails?.currentWorkflowDetails?.length > 0 && (
                    <div className="date-container-in-details">
                      <div
                        className={`issue-timestamp ${serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].status == "Completed" && serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].workflow == "Request Approval" && isCurrentTimeBetween(serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].estimateStartDate, serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].estimateEndDate) ? "is-active-request" : ""}`}
                      >
                        {getDateFormat(
                          serviceListDetails.currentWorkflowDetails[
                            serviceListDetails.currentWorkflowDetails.length - 1
                          ].estimateStartDate,
                        )}
                      </div>
                      <div
                        className="arrow-between arrow-triangle"
                        aria-hidden="true"
                      />
                      <div
                        className={`issue-timestamp ${serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].status == "Completed" && serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].workflow == "Request Approval" && isCurrentTimeBetween(serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].estimateStartDate, serviceListDetails.currentWorkflowDetails[serviceListDetails.currentWorkflowDetails.length - 1].estimateEndDate) ? "is-active-request" : ""}`}
                      >
                        {getDateFormat(
                          serviceListDetails.currentWorkflowDetails[
                            serviceListDetails.currentWorkflowDetails.length - 1
                          ].estimateEndDate,
                        )}
                      </div>
                    </div>
                  )}
                  <div className="issue-status-description">
                    {printStatus(serviceListDetails, serviceAssignee)}
                  </div>
                </div>
                <div className="detailed-description">
                  <div className="description-header">DESCRIPTION</div>
                  <div className="description-details">
                    {serviceListDetails.description}
                  </div>
                </div>
              </Row>
            </div>
            <div className="workflow-wrapper-chief-engineer">
              <div className="workflow-header">WORK FLOW</div>
              <div className="workflow-steps">
                {serviceWorkflowList.map((workflow, i) =>
                  workflow.manipulated &&
                    workflow.workflow != "Report Work" &&
                    workflow.workflow != "Review Work" ? (
                    <div
                      className={
                        workflow?.approverRoleCode === roleCode &&
                          workflow.status == "Pending" &&
                          workflow.workflow == "Request Approval"
                          ? "step-summary active-workflow"
                          : "step-summary"
                      }
                      key={i}
                    >
                      <div className="worflow-diagram-chief-engineer">
                        <div className="workflow-round">
                          {workflow.status === "Completed" ||
                            workflow.status === "Cancelled" ? (
                            <div className="workflow-round-completed"></div>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="workflow-arrow"></div>
                      </div>
                      <div className="step-details">
                        <div className="step-description">
                          {workflow.workflow}
                        </div>
                        <div className="step-timestamp">
                          {getDateFormat(workflow.assignedDate)}
                        </div>
                      </div>
                      <div className="step-approval">
                        <div className="step-approver-details">
                          <div className="created-user">
                            {workflow.createdUserRole === "Service Engineer"
                              ? engineerName && engineerName.trim() !== ""
                                ? engineerName
                                : workflow.createdUser
                              : workflow.createdUser}
                          </div>
                          <div className="created-user-role">
                            {workflow.createdUserRole === "Service Engineer" ? (
                              <>{workflow.createdUserRole}</>
                            ) : workflow.approverRoleName !== null ? (
                              "Pending with " + workflow.approverRoleName
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="!serviceRecordList.isAssignee ? step-status : step-status button">
                          {roleCode !== null &&
                            workflow?.approverRoleCode === roleCode &&
                            workflow.status == "Pending" &&
                            workflow.workflow == "Request Approval" ? (
                            <Button
                              className="pending-button"
                              onClick={handleShow}
                              disabled={disableButton}
                            >
                              Take Action
                            </Button>
                          ) : (
                            <div className="workflow.status==''? '': pending-status">
                              {workflow.status}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : workflow.workflow != "Report Work" &&
                    workflow.workflow != "Review Work" ? (
                    <div className="step-summary" key={i}>
                      <div className="worflow-diagram-chief-engineer">
                        <div className="workflow-round">
                          {workflow.status === "Completed" ||
                            workflow.status === "Cancelled" ? (
                            <div className="workflow-round-completed"></div>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="workflow-arrow"></div>
                      </div>
                      <div className="step-details">
                        <div className="step-description">
                          {workflow.workflow}
                        </div>
                        <div className="step-timestamp">
                          {getDateFormat(workflow.assignedDate)}
                        </div>
                      </div>
                      <div className="step-approval">
                        <div className="step-approver-details">
                          <div className="created-user">
                            {workflow.createdUser}
                          </div>
                          <div className="created-user-role">
                            {workflow.createdUserRole}
                          </div>
                          {workflow.createdUserRole === "Service Engineer" && (
                            <div
                              className="created-user-role"
                              style={{ top: "2px", position: "relative" }}
                            >
                              {contactLoading ? (
                                <Loader
                                  type="TailSpin"
                                  color="#2546B1"
                                  height={20}
                                  width={20}
                                  timeout={300000}
                                  style={{
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                  }}
                                />
                              ) : (
                                (() => {
                                  if (
                                    phoneNumber ===
                                    "Contact number not available"
                                  ) {
                                    return (
                                      <span>
                                        <i
                                          className="pi pi-phone"
                                          style={{
                                            color: "green",
                                            top: "2px",
                                            position: "relative",
                                          }}
                                        ></i>
                                        &nbsp;
                                        <span
                                          style={{
                                            color: "#524e4e",
                                            fontStyle: "italic",
                                          }}
                                        >
                                          {phoneNumber}
                                        </span>
                                      </span>
                                    );
                                  } else {
                                    return (
                                      <a
                                        href={`tel:${phoneNumber}`}
                                        style={{ textDecoration: "none" }}
                                      >
                                        <i
                                          className="pi pi-phone"
                                          style={{
                                            color: "green",
                                            top: "2px",
                                            position: "relative",
                                          }}
                                        ></i>{" "}
                                        &nbsp;
                                        <span style={{ color: "#212529" }}>
                                          {phoneNumber}
                                        </span>
                                      </a>
                                    );
                                  }
                                })()
                              )}
                            </div>
                          )}
                          {workflow.workflow === "Access Request Raised" &&
                            workflow.status === "Completed" &&
                            serviceListDetails?.editedDate && (
                              <div
                                className="created-user-role"
                                style={{
                                  fontSize: "12px",
                                  marginTop: "4px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "rgb(33 37 41)",
                                    fontWeight: 'bold',
                                  }}
                                >
                                  Edited on{" "}
                                </span>

                                <span
                                  style={{
                                    color: "rgb(165 134 134)",
                                    fontWeight: 600,
                                  }}
                                >
                                  {getDateFormat(serviceListDetails.editedDate)}
                                </span>
                              </div>
                            )}
                        </div>

                        <div className="step-status">{workflow.status}</div>
                      </div>
                    </div>
                  ) : null,
                )}
              </div>

              <div>
                {!hasReportWorkSet &&
                  serviceListDetails.assigneeJob === "Service Engineer" &&
                  isEpochInPast(latestEntry.estimateEndDate) &&
                  roleCode == latestEntry.approverRoleCode &&
                  latestEntry.status !== "Cancelled" &&
                  serviceListDetails?.revokeAccessEnabled &&
                  serviceListDetails?.revokeDetails == null &&
                  (serviceListDetails.configureStatus ==
                    "User granted access to equipment" ||
                    serviceListDetails.deviceBehindSm) ? (
                  <button
                    className="revoke-access-btn"
                    type="button"
                    onClick={() => setShowRevokeModal(true)}
                  >
                    Revoke Access
                  </button>
                ) : (
                  ""
                )}
                {/* Revoke Remote Access Modal */}
                <Modal
                  show={showRevokeModal}
                  onHide={() => setShowRevokeModal(false)}
                  centered
                  className="revoke-remote-modal"
                  backdropClassName="revoke-remote-modal-backdrop"
                  animation={false}
                >
                  <Modal.Body className="revoke-remote-modal-body">
                    <div className="revoke-remote-title">
                      Revoke Remote Access
                    </div>
                    {serviceListDetails?.deviceBehindSm &&
                      serviceListDetails?.pendingRequests ? (
                      <div className="revoke-remote-warning-banner">
                        <FiAlertTriangle
                          className="revoke-remote-warning-icon"
                          size={18}
                        />
                        <span className="text-left">
                          Another request is in progress. Revoking access will
                          cancel all pending and active requests on this device
                          and immediately terminate remote access for all
                          affected sessions.
                        </span>
                      </div>
                    ) : null}

                    <div className="revoke-remote-desc">
                      Please confirm that you've contacted the service engineer
                      before revoking access.
                    </div>
                    <div className="revoke-remote-checkbox-row">
                      <Form.Check
                        type="checkbox"
                        id="contacted-engineer-checkbox"
                        checked={hasContactedEngineer}
                        onChange={(e) =>
                          setHasContactedEngineer(e.target.checked)
                        }
                        label="I have contacted the service engineer"
                      />
                    </div>
                    {!contactLoading ? (
                      <div className="revoke-remote-phone-row">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f5f7fa",
                            borderRadius: "8px",
                            padding: "8px 16px",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                            minWidth: 0,
                            gap: "16px",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 600,
                              color: "#2546B1",
                              fontSize: "1rem",
                              maxWidth: "60%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "inline-block",
                              verticalAlign: "middle",
                            }}
                          >
                            {engineerName}
                          </span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <FaPhoneAlt
                              style={{ color: "#2546B1", fontSize: 18 }}
                            />
                            <span
                              style={{
                                color: "#212529",
                                fontWeight: 500,
                                fontSize: "1rem",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {phoneNumber}
                            </span>
                          </span>
                        </div>
                      </div>
                    ) : (
                      <Loader
                        type="TailSpin"
                        color="#2546B1"
                        height={20}
                        width={20}
                        timeout={300000}
                        style={{
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    )}

                    <div className="revoke-remote-reason-row">
                      <Form.Group
                        controlId="revokeReasonTextarea"
                        style={{ width: "100%" }}
                      >
                        <Form.Label
                          style={{
                            fontWeight: 500,
                            fontSize: "1rem",
                            marginBottom: 5,
                            float: "left",
                          }}
                        >
                          Reason for revoking access
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={revokeReason}
                          onChange={(e) => setRevokeReason(e.target.value)}
                          maxLength={250}
                          placeholder="Enter reason (required)"
                          className="revoke-remote-reason-textarea"
                          style={{ resize: "none", fontSize: "1rem" }}
                        />
                      </Form.Group>
                    </div>
                    <div className="revoke-remote-btn-row">
                      <Button
                        className="revoke-remote-call-btn"
                        style={{
                          background: "#2546B1",
                          border: "none",
                          flex: 1,
                          marginRight: 8,
                          opacity:
                            phoneNumber &&
                              phoneNumber.trim() &&
                              !phoneNumber
                                .trim()
                                .toLowerCase()
                                .includes("not available")
                              ? 1
                              : 0.5,
                          cursor:
                            phoneNumber &&
                              phoneNumber.trim() &&
                              !phoneNumber
                                .trim()
                                .toLowerCase()
                                .includes("not available")
                              ? "pointer"
                              : "not-allowed",
                        }}
                        onClick={() => {
                          if (phoneNumber && phoneNumber.trim()) {
                            window.open(`tel:${phoneNumber.trim()}`, "_self");
                          }
                        }}
                        disabled={
                          !phoneNumber ||
                          !phoneNumber.trim() ||
                          phoneNumber
                            .trim()
                            .toLowerCase()
                            .includes("not available")
                        }
                      >
                        Call
                      </Button>
                      <Button
                        className="revoke-remote-revoke-btn"
                        style={{
                          background:
                            hasContactedEngineer && revokeReason.trim() != ""
                              ? "#FF3B3B"
                              : "#bdbdbd",
                          border: "none",
                          flex: 1,
                        }}
                        // disabled={
                        //   !hasContactedEngineer || revokeReason.trim() === ""
                        // }
                        disabled={false}
                        onClick={() => {
                          // TODO: Implement actual revoke logic here
                          revokeRequestSession();
                          setShowRevokeModal(false);
                        }}
                      >
                        Revoke Access
                      </Button>
                    </div>
                    <div className="revoke-remote-cancel-row">
                      <Button
                        variant="link"
                        className="revoke-remote-cancel-btn"
                        onClick={() => {
                          setShowRevokeModal(false);
                          setRevokeReason("");
                          setHasContactedEngineer(false);
                        }}
                        style={{
                          color: "#2546B1",
                          textDecoration: "none",
                          width: "100%",
                          textAlign: "center",
                          paddingLeft: 0,
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
            {serviceListDetails?.revokeDetails && (
              <div className="workflow-revoke-wrapper">
                <div className="revoke-info-banner">
                  <span className="revoke-icon">
                    <FiAlertTriangle color="#FF3B3B" size={16} />
                  </span>
                  <span className="revoke-text">
                    Session revoked by{" "}
                    <strong
                      className="truncate-ellipsis"
                      title={serviceListDetails.revokeDetails.createdUser}
                    >
                      {serviceListDetails.revokeDetails.createdUser}
                    </strong>{" "}
                    on{" "}
                    <strong>
                      {" "}
                      {getDateFormat(
                        serviceListDetails.revokeDetails.assignedDate,
                      )}
                    </strong>{" "}
                    due to{" "}
                    <strong
                      className="truncate-ellipsis"
                      title={serviceListDetails.revokeDetails.comments}
                    >
                      {serviceListDetails.revokeDetails.comments}
                    </strong>
                  </span>
                </div>
              </div>
            )}
            {reportedWorkData && (
              <div className="reported-work-wrapper">
                <div className="reported-work-header">REPORTED WORK</div>
                <div className="reported-work-card">
                  <div className="reported-work-meta">
                    <div className="reported-work-user-info">
                      <div className="reported-work-user">
                        {reportedWorkData.createdUser}
                      </div>
                      <div className="reported-work-role">
                        {reportedWorkData.createdUserRole}
                      </div>
                    </div>
                    <div className="reported-work-date">
                      {getDateFormat(reportedWorkData.assignedDate)}
                    </div>
                  </div>
                  {reportedWorkData.comments && (
                    <div className="reported-work-comments-section">
                      <div className="reported-work-comments-label text-left">
                        Comments
                      </div>
                      <div className="reported-work-comments-text">
                        {reportedWorkData.comments}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="pending-steps-wrapper">
              {/* <div className="task-header">TO BE STARTED</div>

            <div className="task-list-body">
              {workFlowPending.map((step, index) => (
                <div className="task-list-details" key={index}>
                  <div className="workflow-round"></div>
                  <div className="task-name">{step}</div>
                </div>
              ))}
            </div> */}
            </div>
          </div>
          <div className="access-approve-modal-wrapper-chief-engineer">

            <Modal
              className="request-updated-modal"
              animation={false}
              show={showRecordEditedModal}
              onHide={handleEditClose}
              backdrop={false}
              style={{ background: "white" }}
            >
              <Modal.Header>
                <div className="request-updated-modal-head">
                  ACCESS REQUEST UPDATE
                </div>
                <CloseButton onClick={handleEditClose}></CloseButton>
              </Modal.Header>
              <Modal.Body>
                <div className="request-updated-modal-details-wrapper">
                  <div className="request-update-message">
                    <p>
                      The requester has updated this request since you opened it.
                      The details shown may be outdated. Refreshing will discard any
                      unsaved changes.
                    </p>

                    <b><p className="request-update-highlight">
                      Please refresh and proceed.
                    </p></b>
                  </div>

                  <div className="refresh-cancel-button-group">
                    <Button
                      variant="secondary refresh-button"
                      onClick={handleRefreshRequest}
                    >
                      REFRESH
                    </Button>

                    <Button
                      variant="secondary cancel-button"
                      onClick={() => setShowRecordEditedModal(false)}
                    >
                      CANCEL
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>


            <Modal
              className="access-approve-modal-chief-engineer"
              animation={false}
              show={show && !showRecordEditedModal}
              onHide={handleClose}
              backdrop={false}
              style={{ background: "white" }}
            >
              <Modal.Header>
                <div className="access-request-header-chief-engineer">
                  ACCESS REQUEST
                </div>
                <CloseButton onClick={cancelAction}></CloseButton>
              </Modal.Header>
              <Modal.Body>
                <div className="service-provider-details-wrapper">
                  <div className="service-provider-image">
                    <img className="user-icon"></img>
                  </div>
                  <div className="service-provider-name">
                    {createdUserRole} has requested access
                  </div>
                  <div className="vessel-details">
                    <div className="welcome">
                      <div className="user-box">
                        {vesselInfo && vesselInfo.imageURL !== null ? (
                          <img src={vesselInfo.imageURL} alt="" />
                        ) : (
                          <img src="user-icon" alt="" />
                        )}
                      </div>
                      {vesselName ? (
                        <div className="vessel-name">{vesselName}</div>
                      ) : (
                        <div className="vessel-name">
                          {vesselInfo?.displayName}
                        </div>
                      )}
                      <div className="vessel-number eqipStyle equiText">
                        {serviceListDetails.equipment}
                      </div>
                      {vesselInfo && vesselInfo.imo !== null ? (
                        <div className="vessel-number imoText">
                          IMO : {vesselInfo.imo}
                        </div>
                      ) : (
                        <div className="vessel-number imoText">IMO : N.A</div>
                      )}
                    </div>
                  </div>
                  <div className="service-request-reason">
                    <div className="reason-header">DESCRIPTION :</div>
                    <div className="reason-description">
                      {serviceListDetails.description}
                    </div>
                  </div>
                  <div className="service-requestedBy-details">
                    <div className="service-requestBy-label">
                      REQUESTED BY :
                    </div>
                    <div className="service-requestor-name">{createdUser}</div>
                  </div>
                  <div className="service-request-timestamp">
                    <div className="service-requesttimestamp-label">
                      REQUESTED ON :
                    </div>
                    <div className="service-request-timestamp" style={{ display: "table-cell", float: "none", textAlign: "left" }}>
                      {getFormattedDate(serviceListDetails.createdDate)}
                    </div>
                  </div>
                  <div
                    className="service-desired-duration"
                    style={increaseHeight}
                  >
                    <div className="service-desired-label">DESIRED START :</div>
                    <div className="service-desired-timestamp">
                      <Calendar
                        appendTo={"self"}
                        id="startCalender"
                        value={selectedStartDate}
                        onChange={(e) => {
                          handleStartDateChange(e);
                          showCalendar(true);
                          setErrors({});
                          setIsDisabledApprove(false);
                        }}
                        onShow={() => setMinimumStartDate(new Date())}
                        showTime
                        showIcon
                        showSeconds
                        minDate={minimumStartDate}
                        hourFormat="12"
                        timeFormat="hh:mm:ss a"
                        style={{
                          maxWidth: "450px",
                          height: "35px",
                        }}
                        dateFormat="dd-mm-yy"
                        className={
                          "start-calendar " +
                          (errors.selectedStartDate ? "error-highlight" : "")
                        }
                      />
                    </div>
                    {errors.selectedStartDate && (
                      <span class="error-msg error-start">
                        {errors.selectedStartDate}
                      </span>
                    )}
                  </div>
                  <div
                    className="service-desired-duration"
                    style={increaseHeight}
                  >
                    <div className="service-desired-label">DESIRED END :</div>
                    <div className="service-desired-timestamp">
                      <Calendar
                        appendTo={"self"}
                        id="startCalender"
                        value={selectedEndDate}
                        onChange={(e) => {
                          calculateDuration(e.value);
                          setDateEnd(e.value);
                          showCalendar(true);
                          setErrors({});
                          setIsDisabledApprove(false);
                        }}
                        showTime
                        showIcon
                        showSeconds
                        minDate={selectedStartDate || today}
                        maxDate={
                          selectedStartDate &&
                            vesselInfo?.maxRemoteAccessDuration
                            ? new Date(
                              selectedStartDate.getTime() +
                              vesselInfo.maxRemoteAccessDuration *
                              60 *
                              60 *
                              1000,
                            )
                            : null
                        }
                        hourFormat="12"
                        timeFormat="hh:mm:ss a"
                        style={{
                          maxWidth: "450px",
                          height: "35px",
                        }}
                        dateFormat="dd-mm-yy"
                        className={
                          "start-calendar " +
                          (errors.selectedEndDate ? "error-highlight" : "")
                        }
                      />
                    </div>
                    {errors.selectedEndDate && (
                      <span class="error-msg error-start">
                        {errors.selectedEndDate}
                      </span>
                    )}
                  </div>

                  <div className="service-request-duration">
                    <div className="service-requestduration-label">
                      DURATION :
                    </div>
                    <div className="service-duration-timestamp">
                      {difference}
                    </div>
                  </div>

                  <div className="approval-denial-comments">

                    <Form.Group className="mb-0" controlId="ControlTextarea">
                      <div className="comments-header-row">
                        <Form.Label>COMMENTS :</Form.Label>
                        <span className="comments-helper-text">
                          Please fill or select a template
                        </span></div>
                      <Form.Control
                        as="select"
                        onChange={handleCommentTemplateChange}
                        className="comment-template-dropdown"
                        style={{ marginBottom: "10px" }}
                      >
                        <option value="">Select a comment template</option>

                        {Object.entries(commentTemplates).map(([group, options]) => (
                          <optgroup key={group} label={`▶ ${group}`}>
                            {options.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </Form.Control>

                      <Form.Control
                        as="textarea"
                        rows={5}
                        value={commentValue}
                        onChange={(e) => populateCommentValue(e)}
                        maxLength={250}
                        disabled={isDisabled}
                      />

                    </Form.Group>
                  </div>
                  <div className="warranty-approval-warning">
                    <FiAlertTriangle />
                    <span>
                      {serviceListDetails.isWarrantyEnabled
                        ? "Approving this request will consume requester's credits."
                        : "Approving this request will consume your available credits."}
                    </span>
                  </div>
                  <div className="approve-deny-button-group">
                    <Button
                      variant="secondary deny-button"
                      onClick={() =>
                        approveDenyAccess(serviceListDetails, "reject")
                      }
                      disabled={isDisabled}
                    >
                      DENY
                    </Button>
                    <Button
                      variant="secondary approve-button"
                      onClick={() => setShowApproveConfirmation(true)}
                      disabled={isDisabledApprove}
                    >
                      PROCEED
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>

            <Modal
              className="approve-confirmation-modal"
              show={showApproveConfirmation}
              onHide={() => setShowApproveConfirmation(false)}
              backdrop="static"
              backdropClassName="approve-confirmation-backdrop"
            >
              <Modal.Header closeButton>
                <Modal.Title as="h5">CONFIRM APPROVAL</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to approve this remote access request from{" "}
                <span className="approval-confirmation-date">
                  {selectedStartDate ? getFormattedDate(selectedStartDate) : "the selected start date"}
                </span>{" "}
                to{" "}
                <span className="approval-confirmation-date">
                  {selectedEndDate ? getFormattedDate(selectedEndDate) : "the selected end date"}
                </span> ? Please note that as an approver you can change the start and end time before approving the request.
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowApproveConfirmation(false)}
                >
                  CANCEL
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowApproveConfirmation(false);
                    approveDenyAccess(serviceListDetails, "approve");
                  }}
                >
                  APPROVE
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </>
      )}
      <Toast ref={toast} />
    </div>
  );
};

export default ServiceDetails;
